import React from 'react'
import Layout from './../components/layout/index'
import pp from "../assets/tc.png"

const sections = [
  {
    heading: "Acceptance Of Terms Through Subscription/Access",
    paragraphs: [
      "By subscribing to / accesing the Venture Intelligence databases, newsletters and reports, you signify your agreement to all terms, conditions, and notices contained or referenced herein (the \"Terms & Conditions\"). If you do not agree to these Terms & Conditions please do not use this service. We reserve the right, at our discretion, to update or revise these Terms & Conditions."
    ]
  },
  {
    heading: "Proprietary Rights",
    paragraphs: [
      "You acknowledge and agree that all content and materials available in TSJ Media's Venture Intelligence databases, publications, web sites and this document are protected by copyrights, trademarks, service marks, patents, trade secrets, or other proprietary rights and laws.",
      "Subscription / access to the TSJ Media's Venture Intelligence databases, newsletters and reports is meant for the internal and non-commercial use. Except as indicated in the FAIR USE POLICY below, you agree not to sell, rent, license, transmit or share access in any manner to any other individuals or organisations or AI tools any content available to you as part of your subscription to TSJ Media's products and services including that in the Venture Intelligence databases, newsletters, and reports.",
      "Venture Intelligence products and services are accessible by designated employees of subscribing organizations and only through their registered official logins. The authorization to access and use the products and services is based on their continued employment with the subscribing organizations.",
      "Venture Intelligence will have the rights to monitor activity and usage of its products and services for research and quality assurance purposes."
    ]
  },
  {
    heading: "Fair Use Policy",
    paragraphs: [
      "Upon subscription,"
    ],
    list: [
      "No permission has to be sought from Venture Intelligence/TSJ Media for sharing of the data among users within the subscribing entity. Note: This waiver does not cover exposure of Venture Intelligence data & content to AI tools.",
      "No permission needs to be sought for of use of AGGREGATE DEAL DATA (e.g., Total number of PE investments in the Healthcare sector over the years) in any of articles, presentations, publications and reports that are distributed external to the subscribing entity as long as Venture Intelligence is credited prominently as the source of the data (at least once in these articles, presentations, publications and reports).",
      "Sharing, distributing or transmitting any data or content from Venture Intelligence with individuals or entities outside the subscribing organization, by any means—including print, electronic communication and AI tools—is strictly prohibited without prior written permission from Venture Intelligence/TSJ Media."
    ]
  },
  {
    heading: "Third Party Sites",
    paragraphs: [
      "TSJ Media's Venture Intelligence databases, newsletters and reports provide links to web sites on the Internet that are not the property of TSJ Media. TSJ Media does not assume any responsibility for such content and makes no express or implied warranty about the accuracy, copyright compliance, legality, merchantability, any other aspect of the content of such sites. The inclusion of such a link does not imply endorsement of the site by TSJ Media or any association with its operators."
    ]
  },
  {
    heading: "Refund Policy",
    paragraphs: [
      "In case you are not satisfied with our emailed publications, you can cancel your subscription any time and receive a prorated refund on the unmailed issues. Refund requests for packages including a database have to be exercised within 7 days of purchase. Refunds on the database element of the subscription are not possible as soon as the subscriber (or one of its members) downloads data from the database as a spreadsheet. Discounts for multi-year subscriptions will be adjusted before a refund is made."
    ]
  },
  {
    heading: "Disclaimer Of Warranties",
    paragraphs: [
      "All materials, information, software and other contents included in TSJ Media's Venture Intelligence databases, newsletters and reports (the \"content\") is provided \"as is\" and \"as available\" for your use. The content is provided without warranties of any kind, either express or implied, including, but not limited to, implied warranties of merchantibility or fitness for a particular purpose. TSJ Media undertakes to use reasonable endeavours to ensure that the content is provided in accordance with good professional standards and with due care, diligence and skill. However, TSJ Media shall have no liability or responsibility for any information published on linked third party web sites, contained in any user submissions published on the TSJ Media web sites, or provided by third parties. TSJ Media shall not be liable for any indirect, incidental, consequential, or punitive damages or for lost revenues or profits."
    ]
  },
  {
    heading: "Indemnification",
    paragraphs: [
      "TSJ Media shall defend, indemnify, and hold harmless the customer, its affiliates, and their respective officers, directors, employees, and agents from and against any and all claims, demands, suits, or proceedings brought by a third party alleging that the use, receipt, or operation of the third party's intellectual property rights, including patents, copyrights, trademarks, or trade secrets."
    ]
  },
  {
    heading: "Termination",
    paragraphs: [
      "Upon breach of the above terms & conditions or suspicion thereof, TSJ Media, in order to protect its Intellectual Property, will have the right to terminate the subscription without any notice. No refunds will be applicable in such cases."
    ]
  },
  {
    heading: "Disputes",
    paragraphs: [
      "Any dispute relating to the use of TSJ Media's Venture Intelligence databases, newsletters and reports shall be resolved exclusively by the courts of Chennai, Tamil Nadu in accordance with state and national laws of India."
    ]
  },
]

const highlightAITools = (text) => {
  const parts = text.split("AI tools")
  return parts.flatMap((part, i) => (
    i === 0 ? [part] : [<span key={i} className="text-green-600">AI tools</span>, part]
  ))
}

const Terms = () => {
  return (
    <Layout>
      {/* Hero Banner */}
      <div className="relative h-56 mb-12">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url(${pp})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
        >
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-6 pb-16">
        {/* <h1 className="text-2xl font-semibold text-[#a07924] mb-6">Terms And Conditions</h1> */}
        <div className="space-y-8">
          {sections.map((section, index) => (
            <div key={index}>
              {section.heading && (
                <h2 className="text-lg font-semibold text-[#a07924] mb-2">{section.heading}</h2>
              )}
              <div className="space-y-3">
                {section.paragraphs.map((paragraph, pIndex) => (
                  <p key={pIndex} className="text-[#475569] text-base leading-relaxed">{highlightAITools(paragraph)}</p>
                ))}
              </div>
              {section.list && (
                <ul className="list-disc pl-6 mt-3 space-y-2">
                  {section.list.map((item, lIndex) => (
                    <li key={lIndex} className="text-[#475569] text-base leading-relaxed">{highlightAITools(item)}</li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>
      </div>
    </Layout>
  )
}

export default Terms
